import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from '@nexvia-logistics/ui';
import { DASHBOARD_PATH } from 'config';
import { isStorageVisible } from 'domain/storage/storage-module';
import { useAppFeatures } from 'shared/queries/app-features';

/**
 * NEX-1645 (plan 2026-10-20, Tarea 3.3) — every /storage/* page (routes.tsx) sits behind the storage
 * module's state. With `off` the client web shows nothing of the module, not even a depósito already in
 * course (Johan's answer 8: the API keeps processing its payments): the page goes to Inicio. With
 * `registration_only` and `full` the pages show — a client keeps managing what they already have.
 *
 * It waits for the first answer of GET /app/features instead of reading the "loading → off" fallback as
 * `off`: a link to a page (Mercado Pago's return, an email, a reload) must not bounce while it loads.
 * A failed call does read as `off`.
 *
 * [ASSUMED] the plan said "redirige a /coming-soon", but that route is only NEX-1335's redirect to `/`
 * (→ /login → GuestGuard → Inicio, flashing the login screen): this goes straight to where that chain ends.
 */
export default function StorageModuleGate({ children }: { children: ReactNode }) {
  const { storage, isLoading } = useAppFeatures();

  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <Spinner label="Cargando" />
      </div>
    );
  }
  if (!isStorageVisible(storage)) return <Navigate to={DASHBOARD_PATH} replace />;
  return <>{children}</>;
}
